import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useRef, Fragment } from "react";
import { Box } from "../Box/Box.mjs";
import { Field } from "../private/Field/Field.mjs";
import { ClearField } from "../private/Field/ClearField.mjs";
import { getCharacterLimitStatus } from "../private/Field/getCharacterLimitStatus.mjs";
const validTypes = {
  text: "text",
  password: "password",
  email: "email",
  search: "search",
  number: "number",
  tel: "tel",
  url: "url"
};
const defaultInputModesForType = {
  text: "text",
  password: "text",
  email: "email",
  search: "search",
  number: "numeric",
  tel: "tel",
  url: "url"
};
const TextField = forwardRef(
  ({
    value,
    type = "text",
    onChange,
    onBlur,
    onFocus,
    onClear,
    placeholder,
    characterLimit,
    id,
    clearLabel,
    inputMode,
    step,
    ...restProps
  }, forwardedRef) => {
    const defaultRef = useRef(null);
    const inputRef = forwardedRef || defaultRef;
    const clearable = Boolean(
      typeof onClear !== "undefined" && !restProps.disabled && typeof value === "string" && value.length > 0
    );
    return /* @__PURE__ */ jsx(
      Field,
      {
        ...restProps,
        componentName: "TextField",
        id,
        value,
        secondaryMessage: characterLimit ? getCharacterLimitStatus({
          value,
          characterLimit
        }) : null,
        secondaryIcon: onClear ? /* @__PURE__ */ jsx(
          ClearField,
          {
            id: `${id}-clear`,
            hide: !clearable,
            onClear,
            label: clearLabel,
            inputRef
          }
        ) : null,
        children: (overlays, fieldProps, icon, secondaryIcon, prefix) => /* @__PURE__ */ jsxs(Fragment, { children: [
          icon,
          prefix,
          /* @__PURE__ */ jsx(
            Box,
            {
              component: "input",
              type: validTypes[type],
              value,
              onChange,
              onFocus,
              onBlur,
              placeholder: !restProps.disabled ? placeholder : void 0,
              ...fieldProps,
              inputMode: inputMode || defaultInputModesForType[type],
              step,
              ref: inputRef
            }
          ),
          overlays,
          secondaryIcon
        ] })
      }
    );
  }
);
TextField.displayName = "TextField";
export {
  TextField
};
